import type { RouteLocationNormalized, Router } from 'vue-router';

function normalizeRouteKey(value?: string | null) {
  return (value || '').replace(/^\//, '');
}

export function syncRouteMetaLabels(router: Router, permissions: PermissionItem[], currentRoute?: RouteLocationNormalized) {
  const labels = new Map<string, string>();
  const collectLabels = (items: PermissionItem[]) => {
    items.forEach(item => {
      labels.set(normalizeRouteKey(item.name), item.show_name);
      collectLabels(item.children || []);
    });
  };

  collectLabels(permissions);
  const getLabel = (name: unknown, path: string) => {
    return labels.get(normalizeRouteKey(String(name))) || labels.get(normalizeRouteKey(path));
  };

  router.getRoutes().forEach(route => {
    const label = getLabel(route.name, route.path);
    if (label) route.meta.label = label;
  });

  const currentLabel = currentRoute && getLabel(currentRoute.name, currentRoute.path);
  if (currentLabel && currentRoute) currentRoute.meta.label = currentLabel;
}
